import { DateTime } from 'luxon';
/**
 * ノートクラス
 */
var Note = /** @class */ (function () {
    function Note(props) {
        this.id = props.id;
        this.title = props.title;
        this.createdDatetime = props.createdDatetime;
        this.ownerId = props.ownerId;
        this.ownerName = props.ownerName;
        this.ownerNameRuby = props.ownerNameRuby || null;
        this.updatedDatetime = props.updatedDatetime;
        this.frontPageId = props.frontPageId || null;
        this.frontPageImage = props.frontPageImage || null;
        this.assignmentId = props.assignmentId || null;
        this.moralityMode = props.moralityMode || null;
        this.flagPageId = props.flagPageId || null;
        this.flagPageImage = props.flagPageImage || null;
        this.lastUpdatedPageId = props.lastUpdatedPageId || null;
        this.lastUpdatedPageImage = props.lastUpdatedPageImage || null;
    }
    /** graqhplから受け取ったNoteJsonObjectをNoteオブジェクトに変換するstaticファクトリメソッド */
    Note.fromGql = function (props) {
        return new Note({
            id: props.id,
            title: props.title,
            createdDatetime: DateTime.fromISO(props.createdDatetime),
            ownerId: props.ownerId,
            ownerName: props.ownerName,
            ownerNameRuby: props.ownerNameRuby || null,
            updatedDatetime: DateTime.fromISO(props.updatedDatetime),
            frontPageId: props.frontPageId || null,
            frontPageImage: props.frontPageImage || null,
            assignmentId: props.assignmentId || null,
            moralityMode: props.moralityMode || null,
            flagPageId: props.flagPageId || null,
            flagPageImage: props.flagPageImage || null,
            lastUpdatedPageId: props.lastUpdatedPageId || null,
            lastUpdatedPageImage: props.lastUpdatedPageImage || null,
        });
    };
    Object.defineProperty(Note.prototype, "linkedAssignmentId", {
        get: function () {
            return this.assignmentId !== 'NOT_ASSIGNMENT' ? this.assignmentId : null;
        },
        enumerable: false,
        configurable: true
    });
    Note.prototype.getThumbnail = function (showFlagPage) {
        return (showFlagPage && this.flagPageImage) || this.lastUpdatedPageImage || this.frontPageImage || undefined;
    };
    Note.prototype.getThumbnailPageId = function (showFlagPage) {
        return (showFlagPage && this.flagPageId) || this.lastUpdatedPageId || this.frontPageId || undefined;
    };
    Note.prototype.getOwnerName = function (nameDisplay) {
        return nameDisplay === 'ruby' ? this.ownerNameRuby || this.ownerName : this.ownerName;
    };
    return Note;
}());
export { Note };
